import { t } from "i18next";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { AdminSensorType } from "../../../../../types/types";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";
import { Separator } from "../../../../../ui/Separator";
import { Button } from "../../../../../ui/Button";
import { Input } from "../../../../../ui/Input/Input";
import { useOutletContext } from "react-router-dom";
import DeleteSensor from "../../DeleteSensor";

type Props = {
  id: string | undefined;
  currentSensor: AdminSensorType | undefined;
};

const SensorSettingsTab = ({ id, currentSensor }: Props) => {
  //const [errors, setErrors] = useState([]);
  const [sensors, setSensors] = useOutletContext<[AdminSensorType[], Function]>();

  let [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const { handleSubmit, reset, control } = useForm({
    defaultValues: {
      name: currentSensor?.attributes.name,
      short_name: currentSensor?.attributes.short_name,
      long_name: currentSensor?.attributes.long_name,
      data_key_name: currentSensor?.attributes.data_key_name,
      chart_type: currentSensor?.attributes.chart_type,
    },
  });

  function openDeleteModal() {
    setIsDeleteOpen(true);
  }

  function closeDeleteModal() {
    setIsDeleteOpen(false);
  }

  // Обновление информации о сенсоре
  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/administration/directories/sensor_types/${id}`,
    true
  );

  const onSubmit = (formData: any) => {
    doFetchItemSave({
      method: "PUT",
      data: {
        data: {
          name: formData.name,
          long_name: formData.long_name,
          short_name: formData.short_name,
          data_key_name: formData.data_key_name,
          chart_type: formData.chart_type,
        },
      },
    });
  };

  const editSensor = (itemSaveResponse: { data: unknown }) => {
    const newSensorData = itemSaveResponse.data as unknown as AdminSensorType;
    const withoutCurrentItem = sensors?.filter((sensor) => sensor.id != currentSensor?.id)!;
    setSensors(
      [...withoutCurrentItem, newSensorData].sort(
        (a, b) => Number(a.id) - Number(b.id),
      ),
    );
  };

  useEffect(() => {
    if (!saveResponse) return;
    editSensor(saveResponse);
  }, [saveResponse]);

  return (
    <>
      <div className="pt-8">
        <form onSubmit={handleSubmit(onSubmit)}>
          <ScrollArea>
            <div className="flex flex-col gap-3">
              <Controller
                name="name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("name")}*`} />
                  </div>
                )}
              />
              <Controller
                name="long_name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("long_name")}*`} />
                  </div>
                )}
              />
              <Controller
                name="short_name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("short_name")}*`} />
                  </div>
                )}
              />
              <Controller
                name="data_key_name"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("data_key_name")}*`} />
                  </div>
                )}
              />
              <Controller
                name="chart_type"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <div className="relative space-y-2">
                    <Input {...field} label={`${t("chart_type")}*`} />
                  </div>
                )}
              />

              <Separator />
              <div className="mt-8 flex w-full justify-between">
                <Button variant={"destructive"} size={"sm"} type="button" onClick={() => openDeleteModal()}>
                  {t("delete")}
                </Button>
                <Button variant={"default"} size={"sm"} type="submit">
                  {t("save")}
                </Button>
              </div>
            </div>
          </ScrollArea>
        </form>
      </div>
      <DeleteSensor id={id!} isDeleteOpen={isDeleteOpen} closeModal={closeDeleteModal} />
    </>
  );
};

export default SensorSettingsTab;
